module.exports = __webpack_public_path__ + "static/lpsLogo-94ab84fe639a93903a65829d7caea7bb.png";